// extracted by mini-css-extract-plugin
export var arrow = "_3b-6";
export var changeItem = "_3b-3";
export var changesHeader = "_3b-1";
export var changesList = "_3b-2";
export var container = "_3b-0";
export var pathLabel = "_3b-4";
export var value = "_3b-7";
export var valuesContainer = "_3b-5";